import { renderClient } from './client';

renderClient();
